<template>
  <div class="homepage">
    <!-- Seções da página -->
    <section>
      <VideoPromo />
    </section>

    <section>
      <CardService />
    </section>

    <section>
      <Portifolio />
    </section>
  </div>

  <!-- Ícone do WhatsApp -->
  <div class="image-containerwpp">
    <a :href="whatsappLink" target="_blank" rel="noopener noreferrer">
      <img src="@/assets/Images/whatsapp.png" alt="WhatsApp" />
    </a>
  </div>
</template>

<script>
import CardService from '@/components/CardService.vue';
import Portifolio from '@/components/Portifolio.vue';
import VideoPromo from '@/components/VideoPromo.vue';




export default {
  name: "HomePage",
  components: {
    VideoPromo,
    CardService,
    Portifolio,
   
  },
  data() {
    return {
      // Número de telefone no formato internacional (sem espaços ou caracteres especiais)
      phoneNumber: "64996277435",
      // Mensagem pré-definida
      message: "Oi! 👋 Vim pelo seu site e quero saber mais sobre o processo de criação de site. Podemos conversar? 🚧🏗️",
    };
  },
  computed: {
    // Gera o link do WhatsApp com a mensagem pré-definida
    whatsappLink() {
      return `https://api.whatsapp.com/send?phone=5564996277435&text=Ol%C3%A1%21%20Seja%20muito%20bem-vindo%28a%29%20%C3%A0%20%2A%2AApolotech%2A%2A%21%20%20Agradecemos%20o%20seu%20contato.%20Este%20%C3%A9%20o%20nosso%20canal%20de%20atendimento%20para%20suporte%2C%20d%C3%BAvidas%20sobre%20nossos%20%2A%2Acursos%20de%20programa%C3%A7%C3%A3o%2A%2A%20e%20%2A%2Aservi%C3%A7os%20de%20cria%C3%A7%C3%A3o%20de%20sites%2A%2A.%20%20Para%20que%20possamos%20te%20ajudar%20da%20melhor%20forma%2C%20por%20favor%2C%20nos%20diga%20qual%20a%20sua%20d%C3%BAvida%20ou%20necessidade.%20Deixe%20sua%20mensagem%20e%20retornaremos%20em%20breve.%20%20Estamos%20%C3%A0%20disposi%C3%A7%C3%A3o%20para%20iluminar%20o%20seu%20caminho%20na%20tecnologia%21`;
    },
  },
};
</script>

<style scoped>
/* Título das Seções */
.section-title {
  text-align: center;
  font-size: 2rem;
}

/* Estilo do WhatsApp fixo na tela */
.image-containerwpp {
  background-color: hsl(231, 73%, 75%);
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 50px; /* Tamanho reduzido */
  height: 50px; /* Tamanho reduzido */
  border-radius: 50%;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  z-index: 1000; /* Garante que o ícone fique acima de outros elementos */
  transition: transform 0.3s ease; /* Adiciona uma animação suave ao interagir */
}

.image-containerwpp img {
  width: 100%;
  height: 100%;
  object-fit: contain; /* Ajusta a imagem sem distorção */
}

/* Efeito de hover para interatividade */
.image-containerwpp:hover {
  transform: scale(1.1); /* Aumenta levemente o ícone ao passar o mouse */
}

/* Estilo Responsivo */
@media (max-width: 768px) {
  .section-title {
    font-size: 1.5rem;
  }

  .image-containerwpp {
    width: 40px; /* Tamanho reduzido para dispositivos móveis */
    height: 40px; /* Tamanho reduzido para dispositivos móveis */
    bottom: 15px;
    right: 15px;
  }
}

@media (max-width: 480px) {
  .image-containerwpp {
    width: 35px; /* Tamanho ainda menor para telas muito pequenas */
    height: 35px;
    bottom: 10px;
    right: 10px;
  }
}
</style>